/* Skinko – buscador más liviano.
   - Saca las sugerencias (chips) del contenedor de estado del tema, que se reemplaza por "Buscando…" al escribir.
   - En computadora: desplegable (no pantalla completa), página atenuada detrás y cierre al tocar afuera.
   - Resultados compactos y "Ver todo" siempre visible. */
(function () {
  if (window.__skSearch) return;
  window.__skSearch = true;

  var css = '' +
    '.sk-search-top{padding:4px 0 8px;text-align:left;width:100%}' +
    '.sk-search-top__title{margin:14px 0 8px;font-size:12px;font-weight:600;letter-spacing:.06em;text-transform:uppercase;color:#6b6b6b}' +
    '.sk-search-top__chips{display:flex;flex-wrap:wrap;gap:8px;margin:0;padding:0;list-style:none}' +
    '.sk-search-top__chip{display:inline-flex;align-items:center;gap:6px;min-height:36px;padding:6px 14px;border-radius:999px;border:1px solid rgba(16,21,26,.18);background:#fff;color:#10151a;font-size:14px;line-height:1.2;text-decoration:none;transition:background-color .15s,border-color .15s}' +
    '.sk-search-top__chip:hover,.sk-search-top__chip:focus-visible{background:rgba(187,160,242,.18);border-color:#bba0f2}' +
    '.sk-search-top__chip svg{width:14px;height:14px;opacity:.55}' +
    '.sk-search-top__chip--col{background:rgba(121,128,252,.08);border-color:rgba(121,128,252,.25)}' +
    'search-drawer[results] .sk-search-top,search-drawer[loading] .sk-search-top{display:none}' +
    'search-drawer .search-result-list__item .wt-cart__item__name{font-size:15px!important;line-height:1.3!important;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}' +
    'search-drawer .search-result-more{position:sticky;bottom:0;z-index:2;background:#fff;padding-top:10px;padding-bottom:10px;box-shadow:0 -8px 12px rgba(255,255,255,.95)}' +
    '@media (min-width:900px){' +
      '.search-overlay-on search-drawer.wt-drawer-search--active{bottom:auto!important;height:auto!important;max-height:85vh!important;border-radius:0 0 16px 16px!important;padding-bottom:16px!important;box-shadow:0 16px 32px rgba(16,21,26,.18)}' +
      '.search-overlay-on search-drawer.wt-drawer-search--active .wt-header__search__results{height:auto!important;flex-grow:0!important;max-height:calc(85vh - 140px)!important;overflow-y:auto!important;overscroll-behavior:contain}' +
      '.search-overlay-on search-drawer[results] .search-result-wrapper{height:auto!important;overflow:visible!important}' +
      '.search-overlay-on .sk-search-top{max-width:688px;margin-left:auto;margin-right:auto}' +
      'body.search-overlay-on main#root,body.search-overlay-on .shopify-section-group-footer-group{opacity:.4;transition:opacity .2s ease}' +
    '}';
  var st = document.createElement('style');
  st.id = 'sk-search-css';
  st.textContent = css;
  document.head.appendChild(st);

  function relocate() {
    document.querySelectorAll('.predictive-search-status .sk-search-top').forEach(function (top) {
      var status = top.closest('.predictive-search-status');
      if (status && status.parentNode) status.parentNode.insertBefore(top, status);
    });
  }
  relocate();
  document.addEventListener('DOMContentLoaded', relocate);
  document.addEventListener('shopify:section:load', relocate);

  document.addEventListener('click', function (e) {
    if (window.innerWidth < 900) return;
    var sd = document.querySelector('search-drawer.wt-drawer-search--active');
    if (!sd || sd.contains(e.target)) return;
    e.preventDefault();
    e.stopPropagation();
    var close = sd.querySelector('.wt-header__search__close');
    if (close) close.click();
  }, true);
})();
